<div
  [style.backgroundColor]="backgroundColor | contentBuilderColor"
  [style.borderColor]="textColor | contentBuilderColor"
  class="mt-16"
>
  <div
    class="mx-5 flex flex-grow rounded-lg border border-4 border-solid px-6 py-4"
    [style.backgroundColor]="backgroundColor | contentBuilderColor"
    [style.borderColor]="textColor | contentBuilderColor"
  >
    <input
      appVirtualKeyboard
      [onlyUpperCase]="true"
      type="text"
      [(ngModel)]="voucher"
      [isOverFooter]="true"
      class="flex flex-grow border border-none text-2xl outline-none focus:outline-none focus:ring-0"
      [placeholder]="'kiosk.cart.promotion.inputPlaceholder' | translate"
      [style.backgroundColor]="backgroundColor | contentBuilderColor"
    />
    <app-button-atom
      size="M"
      thickSize="M"
      [label]="'kiosk.cart.promotion.applyButton' | translate"
      [overrideBgColor]="primaryButtonBackgroundColor"
      [overrideTextColor]="primaryButtonTextColor"
      type="kiosk-primary"
      [full]="true"
      (click)="applyVoucher(voucher)"
    ></app-button-atom>
  </div>
  <div
    *ngIf="errorVoucher"
    class="pl-5 pt-5"
  >
    {{ errorVoucher }}
  </div>
  <div
    *ngFor="let coupon of coupons$ | async"
    class="m-5 flex justify-between border-b border-neutral-300 px-4 py-6"
    [style.backgroundColor]="primaryButtonTextColor | contentBuilderColor"
    [style.color]="primaryButtonBackgroundColor | contentBuilderColor"
    [class.opacity-50]="coupon.removeInProgress"
  >
    <div class="flex flex-col items-start justify-center leading-snug lg:text-base">
      <div class="text-xl font-bold">
        <ng-container *ngIf="coupon.name">
          {{ coupon.name }}
        </ng-container>
        <ng-container *ngIf="!coupon.name">
          {{ 'basket.discount-voucher' | translate }} «{{ coupon.code }}»
        </ng-container>
      </div>
      <div
        *ngIf="coupon.type === 'ERROR'"
        class="text-xs text-error-800"
      >
        <ng-container *ngIf="coupon.error">
          {{ 'voucher-modal.voucher-not-available' | translate }}
        </ng-container>
        <ng-container *ngIf="!coupon.error">
          {{ 'basket.invalid-voucher' | translate }}
        </ng-container>
      </div>
      <div *ngIf="coupon.is_removable">
        <app-button-atom
          size="M"
          thickSize="S"
          [label]="'kiosk.cart.promotion.removeButton' | translate"
          [overrideBgColor]="secondaryButtonBackgroundColor"
          [overrideTextColor]="secondaryButtonTextColor"
          type="kiosk-primary"
          icon="icon-c-remove"
          [full]="true"
          (click)="removeCoupon(coupon)"
        ></app-button-atom>
      </div>
    </div>
    <div class="flex flex-row items-center justify-end">
      <div
        class="icon icon-coupon-3 pl-4 text-2xl text-neutral-400"
        *ngIf="coupon.type !== 'ERROR'"
      ></div>
      <div
        class="icon icon-warning-circle pl-4 text-error-800"
        *ngIf="coupon.type === 'ERROR'"
      ></div>
      <div
        class="w-28 text-right text-2xl leading-5"
        *ngIf="coupon.type !== 'ERROR'"
      >
        –
        <app-price-atom
          [bold]="false"
          [amount]="coupon.amount_off ?? 0"
          [format]="true"
          [size]="'2XL'"
        ></app-price-atom>
      </div>
    </div>
  </div>
</div>
